<div>
    <div class="c-title--subsection">Rules & Validations</div>
    <div class="row">
        <div class="col-sm-6 instanceCheck">Instance Check Validation</div>
        <div class="col col-sm-6">
            <ccl-toggle-button
                    [title]="sessionConfig.catalogConfig['instanceCheckValidation'] ? 'Enabled' : 'Disabled'"
                    [isChecked]="sessionConfig.catalogConfig['instanceCheckValidation']"
                    (isCheckedChange)="toggleValidationButton($event)"
            >{{ sessionConfig.catalogConfig['instanceCheckValidation'] ? "Enabled" : "Disabled" }}</ccl-toggle-button
            >
        </div>
    </div>
</div>
<!-- Implement inventory lock to avoid user conflict during session assignment -->
<hr>
<div>
    <div class="c-title--subsection">Inventory Lock</div>
    <div class="row">
        <div class="col-sm-6 instanceCheck">Inventory Lock Validation</div>
        <div class="col col-sm-6">
            <ccl-toggle-button
                    [title]="sessionConfig.catalogConfig['inventoryLock'] ? 'Enabled' : 'Disabled'"
                    [isChecked]="sessionConfig.catalogConfig['inventoryLock']"
                    (isCheckedChange)="toggleInventoryButton($event)"
            >{{ sessionConfig.catalogConfig['inventoryLock'] ? "Enabled" : "Disabled" }}</ccl-toggle-button
            >
        </div>
    </div>
</div>

